export default __webpack_public_path__ + "static/media/home-cafe-img-06.4024e76b.png";